import { Component, Input, ChangeDetectionStrategy } from '@angular/core'
import { MatIcon } from '@angular/material/icon'

@Component({
  selector: 'app-admin-boolean-value',
  standalone: true,
  imports: [MatIcon],
  templateUrl: './admin-boolean-value.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './admin-boolean-value.component.scss',
})
export class AdminBooleanValueComponent {
  @Input({ required: true })
  value!: boolean
}
